module.exports = __webpack_public_path__ + "img/get-coupon-btn.8095249f.png";